import React from "react";
import Utils from "../Utils";

function CustomTextField({
  value,
  onChange,
  Label,
  Icon,
  onClick,
  type = "text",
}) {
  return (
    <Utils.InputContainer>
      <Utils.LabelTextField>{Label}</Utils.LabelTextField>
      <Utils.InputWraper>
        <Utils.InputTextField
          type={type}
          value={value}
          onChange={onChange}
        ></Utils.InputTextField>
        <Utils.InputTextFieldIcon
          src={Icon}
          onClick={onClick}
        ></Utils.InputTextFieldIcon>
      </Utils.InputWraper>
    </Utils.InputContainer>
  );
}

export default CustomTextField;
